import { defineStore } from 'pinia';
import {useOrderDataStore} from "@/stores/orderDataStore";



export const UseMoneyStore = defineStore('moneyStore', {
    state: () => ({
        selectedHowReturnMoney: null,
        iban: null,
        beneficiaryName: null,
        ibanBank: null
    }),

    actions: {

        setIban(value) {
            this.iban = value;

        },

        fullIban() {
            return this.iban !== null ? useOrderDataStore().shippingCountry + this.iban : null;
        },

        $reset() {
            this.selectedHowReturnMoney = null;
            this.iban = null;
            this.beneficiaryName = null;
            this.ibanBank = null;
        }
    },

    persist: true

});